import GroupsInput from './GroupsInput'

export default GroupsInput
